<template>
  <div class="job_list">
    <div class="gsjj">
      <p class="p1">正在热招</p>
      <div class="fg"></div>
    </div>
    <div id="JobListContainer" class="container">
      <div id="JobListSwiperContainer" class="swiper swiper-container">
        <div class="wrap swiper-wrapper">
          <div
            class="page swiper-slide"
            v-for="(ita, num) in jobList"
            :key="num"
          >
            <div class="item" v-for="(it, idx) in ita" :key="idx">
              <div class="left">
                <div class="name">{{ it.name }}</div>
                <div class="detail">
                  <div class="salary">
                    {{ it.salary }}
                  </div>
                  <div v-if="it.yearNum" class="year_num">
                    {{ it.yearNum }}
                  </div>
                  <div v-if="it.education" class="education">
                    {{ it.education }}
                  </div>
                  <div v-if="it.peopleNum" class="people_num">
                    {{ it.peopleNum }}人
                  </div>
                </div>
              </div>
              <div class="right">
                <div v-if="it.name" class="position">
                  <i class="el-icon-location-outline" style="font-size: 24px;margin-right: 10px;transform: translateY(5px);"></i>
                  <span>滨江区 - 长河</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <img
        id="JobListButtonPrev"
        class="prev"
        src="@/assets/images/job/left1.png"
      />
      <img
        id="JobListButtonNext"
        class="next"
        src="@/assets/images/job/right1.png"
      />
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
import "swiper/js/swiper.min.js";

export default {
  components: {},
  data() {
    return {
      jobList: [],
    };
  },
  created() {
    let me = this;
    me.loadJobList();
  },
  methods: {
    loadJobList(params) {
      let me = this;
      params = params || {};
      params.pageNum = params.pageNum || 1;
      params.pageSize = params.pageSize || 999;
      params.beginTime = params.beginTime || "";
      me.mySwiper && me.mySwiper.destroy();
      me._getJobList(params, function () {
        me.$nextTick(() => {
          me.initSwiper();
        });
      });
    },
    _getJobList(params, onInit) {
      this.jobList = [
        [
          {
            name: "java实习生",
            salary: "3k",
            yearNum: "5天/周",
            education: "本科",
            peopleNum: "3",
          },

          {
            name: "前端工程师",
            salary: "10k",
            yearNum: "5天/周",
            education: "本科",
            peopleNum: "1",
          },

          {
            name: "JAVA开发",
            salary: "12k",
            yearNum: "5天/周",
            education: "本科",
            peopleNum: "3",
          },
        ],
      ];
      onInit && onInit();
    },
    initSwiper() {
      var me = this;
      me.mySwiper = new Swiper("#JobListSwiperContainer", {
        loop: false,
        speed: 1500,
        parallax: true,
        slidesPerView: 1,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: "#JobListButtonPrev",
          prevEl: "#JobListButtonNext",
        },
      });
      //鼠标移出隐藏按钮，移入显示按钮
      let emt = document.getElementById("JobListContainer");
      emt.onmouseover = () => {
        var nv = me.mySwiper.navigation;
        nv.$nextEl.removeClass("hide");
        nv.$prevEl.removeClass("hide");
      };
      var mouserout = (emt.onmouseout = () => {
        var nv = me.mySwiper.navigation;
        nv.$nextEl.addClass("hide");
        nv.$prevEl.addClass("hide");
      });
      mouserout();
    },
  },
};
</script>

<style lang="scss" scoped>
.gsjj {
  width: 208px;
  height: 99px;
  // background-color: #073875;
  margin: 40px auto;
}
.fg {
  width: 165px;
  height: 5px;
  background: #0a41ff;
  border-radius: 0px 0px 0px 0px;
  margin: 47px 21px 0px 22px;
}
.p1 {
  width: 208px;
  height: 52px;
  font-size: 52px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #333333;
  background-color: rgba(255, 255, 255, 0);

  line-height: 93px;
  // -webkit-background-clip: text;
  // -webkit-text-fill-color: transparent;
}
.job_list .hide {
  opacity: 0;
}

.job_list .next,
.job_list .prev {
  transition: opacity 0.5s;
}

.job_list {
  width: 100%;
  font-size: 16px;
  // background: #1C2646;
  overflow: hidden;
  box-sizing: border-box;
  padding: 0 160px;
}

.job_list .title {
  font-size: 24px;
  text-align: center;
}

.job_list .container {
  width: 100%;
  margin: 0 auto;
  position: relative;
}

.job_list .swiper {
  width: 100%;
  min-width: 550px;
  margin: 0 auto;
}

.job_list .item {
  width: 100%;
  height: 164px;
  padding: 0 160px;
  margin-bottom: 1px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  border-bottom: 1px solid #6e6e6e;
}

.job_list .left {
  width: 60%;
  padding-top: 30px;
  float: left;
}

.job_list .name {
  font-size: 36px;
  line-height: 36px;
  padding-left: 30px;
}

.job_list .detail {
  margin: 20px 0 40px;
  line-height: 40px;
  display: flex;
  flex-direction: row;
  padding-left: 30px;
}

.job_list .detail div {
  line-height: 26px;
  margin: 6px 5px 0 0;
  padding: 0 10px;
  color: #666;
  border-radius: 3px;
  text-align: center;
}

.job_list .detail .salary {
  padding-left: 0;
  font-size: 28px;
  color: #333333;
  background: transparent;
}

.job_list .right {
  width: 39.9%;
  text-align: right;
  float: right;
}

.job_list .position {
  padding-right: 30px;
}

.job_list .position span {
  margin-left: 10px;
  vertical-align: middle;
}

.job_list .position svg {
  vertical-align: middle;
}

.job_list .prev {
  width: 50px;
  left: 0;
  top: 100px;
  z-index: 999;
  position: absolute;
}

.job_list .next {
  width: 50px;
  right: 0;
  top: 100px;
  z-index: 999;
  position: absolute;
}
.year_num {
  width: 80px;
  background: #f2f2f2;
  border-radius: 4px 4px 4px 4px;
}
.education {
  width: 80px;
  background: #f2f2f2;
  border-radius: 4px 4px 4px 4px;
}
.people_num {
  width: 80px;
  background: #f2f2f2;
  border-radius: 4px 4px 4px 4px;
}
</style>